module.exports = __webpack_public_path__ + "img/icon_item5.76aa4397.png";